import {Translation} from '@/i18n/locales/type.ts';

const zhHans: Translation = {
  home: {
    firstVisit: '	我是第一次来，没有预约',
    returningVisitor: '请输入您的电话号码或电子邮箱。',
    error_message: {
      invalid_token: '网络连接不稳定。',
      search: '搜索过程中发生错误。',
      checkin: '办理入住过程中发生错误。如果问题持续存在，请联系前台。',
    },
    dialog_message: {
      reservation: {
        checked_in: '您的预约已确认。办理入住已完成。',
        no_customer: '未找到客户信息。\n请再次检查电话号码或电子邮件。',
      },
      walkin: {
        checked_in: '办理入住已完成。请稍等片刻，我们将按顺序为您服务。',
        no_customer_title: '未找到您的信息。',
        no_customer_description: '这是您第一次来访吗？',
        start_first_visit: '开始首次登记',
        no_booking_title: '{{name}}，我们可以为您办理当天登记。',
        no_booking_description:
          '我们可以为您办理当天登记。\n根据现场情况，可能需要等待，部分项目也可能受到限制。',
        start_checkin: '办理登记',
      },
      no_booking: {
        title: '未找到预约信息',
        description:
          '为了提供细心的诊疗和充分的咨询时间，我们采用预约制运营。\n如果您已经预约，请向前台咨询。',
      },
      invalid_building: {
        title:
          '医院信息不正确。如果您要办理登记的医院不是“首尔江南缪斯诊所主楼2层”，请向前台咨询正确的登记网站地址。',
      },
      common: {
        confirm: '确认',
        cancel: '取消',
      },
      confirm: {
        title: '{{name}}，您好！',
        description: '现在要进行登记吗？',
        confirm: '是的，请帮我登记',
        cancel: '否',
      },
    },
    form: {
      title: {
        name: '预约姓名',
        phone: '电话号码',
        email: '电子邮件',
      },
      placeholder: {
        name: '请输入您的姓名',
        phone: '请输入您的电话号码',
        email: '请输入您的电子邮件',
      },
      description: '请至少输入电话号码或电子邮件中的一项。',
      button: {
        title: '办理登记',
        loading: '搜索中...',
      },
      birth: {
        title: '请输入出生日期以验证您的信息。',
        year: '年',
        month: '月',
        day: '日',
      },
    },
    customer_info: {
      title: '客户信息',
      name: '姓名',
      phone: '电话号码',
      email: '电子邮件',
      button_title: '继续办理入住',
    },
    language_select: {
      button_title: '🌐 更改语言 / Language',
    },
  },
  common: {
    or: '或',
  },
  createChart: {
    title: '新建档案登记',
    error_message: {
      invalid_form: '请输入所有信息。',
      checkin: '办理入住过程中发生错误。',
    },
    dialog_message: {
      complete: {
        title:
          '档案创建及入住已完成。\n当天访问的客户可能需要等待。感谢您的耐心等待。',
        button_title: '确认',
      },
    },
    form: {
      name: {
        title: '预约姓名',
        placeholder: '请输入您的姓名。',
        passport_notice:
          '为了确保准确的预约和顺畅的服务，请非韩国国籍的客户输入护照上的英文姓名。',
      },
      phone: {
        title: '电话号码',
        placeholder: '请输入您的电话号码。',
      },
      email: {
        title: '电子邮件',
        placeholder: '请输入您的电子邮件。',
      },
      birth: {
        title: '出生日期',
        year: '年',
        month: '月',
        day: '日',
      },
      gender: {
        title: '性别',
        male: '男',
        female: '女',
      },
      button: {
        title: '创建档案并入住',
        loading: '正在创建档案...',
      },
    },
  },
};

export default zhHans;
